import SuccessIcon from 'assets/success_icon.svg';
import { FC } from 'react';

import { Box, Typography } from '@mui/material';

type Props = {
  firstPassword?: boolean;
};

export const RecoverySucess: FC<Props> = ({ firstPassword }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography component="h1" variant="h5" fontSize={24} fontWeight={400}>
        {firstPassword
          ? 'Sua senha foi definida!'
          : 'Sua senha foi redefinida!'}
      </Typography>

      <Box my={4} component="img" alt="Ícone conta" src={SuccessIcon} />

      <Typography textAlign="center" mt={1}>
        Volte ao aplicativo e insira suas credenciais de acesso.
      </Typography>
    </Box>
  );
};
